import type { LoaderFunctionArgs, MetaFunction } from 'react-router';
import { generateMeta } from '~/services/meta';
import AiToolTypeListing from '~/components/AiToolTypeListing';
import { prompts } from '~/services';
import { useLoaderData } from 'react-router';
import type { SitemapFunction } from 'remix-sitemap';

const appsCategories = [
    {
        name: 'word',
        prompts: [
            'fix-grammar',
            'improve',
            'paraphrase',
            'summarize',
            'translate',
        ],
    },
    {
        name: 'excel',
        prompts: ['generate-excel-formula', `explain-excel-formula`],
    },
    {
        name: 'teams',
        prompts: [
            'reply-chat',
            'fix-grammar',
            'greeting',
            'paraphrase',
            'summarize',
            'translate',
            'apology',
        ],
    },
    {
        name: 'powerpoint',
        prompts: [
            'slides-outline',
            `text-to-slide`,
            'shorter',
            'summarize',
            'simplify',
        ],
    },
    {
        name: 'outlook',
        prompts: [
            'mail-improve-draft',
            `mail-reply`,
            'positive-reply-customer-email',
            'negative-reply-customer-email',
            'angry-customer-email',
            'mail-subject-line-creator',
        ],
    },
];

export const sitemap: SitemapFunction = ({ config, request }) => {
    const categories = Array.from(new Set(prompts.map((p) => p.type)));
    const appsCats = appsCategories.map((app) => app.name);

    return [...appsCats, ...categories].map((category) => ({
        loc: `/tools/${category}`,
        lastmod: new Date().toISOString(),
        exclude: false,
    }));
};

export const meta: MetaFunction = ({ data }) => {
    return generateMeta({
        title: `Free AI ${data.category.toUpperCase()} tools | AI tools to automate routine business tasks`,
        description: `Discover the best free AI tools for Word, Excel, PowerPoint, and other business apps. Improve writing, automate spreadsheets, and supercharge presentations with ChatGPT-powered assistants — no cost to start!`,
    });
};

export async function loader({ params }: LoaderFunctionArgs) {
    const category = params.category;
    const appCat = appsCategories.find((a) => a.name === category);
    const filteredPrompts = (
        appCat
            ? prompts.filter((p) => appCat.prompts.includes(p.id))
            : prompts.filter((p) => p.type === category)
    ).filter((p) => p.id !== 'ocr-text');

    if (!filteredPrompts || filteredPrompts.length === 0) {
        throw new Response(`Can not find prompts category  ${category}`, {
            status: 404,
        });
    }

    return Response.json({ prompts: filteredPrompts, category });
}

export default function Index() {
    const { prompts, category } = useLoaderData();
    return (
        <AiToolTypeListing
            prompts={prompts}
            title={category}
            description={''}
        />
    );
}
